import {
  useMutation,
  useQuery
} from '@tanstack/vue-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query'
import {
  computed,
  unref
} from 'vue'
import type {
  MaybeRef
} from 'vue'
import type {
  BackendErrorEntity,
  PatchCardPaymentMethodBodyDto,
  PaymentIntentEntity,
  PaymentMethodEntity,
  SetupIntentEntity
} from '.././types'
import { fetchApiInstance } from '../../fetchApiInstance';
import type { ErrorType, BodyType } from '../../fetchApiInstance';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const apiGetAuctionPaymentIntent = (
    auctionId: MaybeRef<string | undefined | null>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      auctionId = unref(auctionId);
      
      return fetchApiInstance<PaymentIntentEntity>(
      {url: `/paymentProvider/auction/${auctionId}/paymentIntent`, method: 'GET'
    },
      options);
    }
  

export const getApiGetAuctionPaymentIntentQueryKey = (auctionId: MaybeRef<string | undefined | null>,) => {
    return ['paymentProvider','auction',auctionId,'paymentIntent'] as const;
    }

    
export const getApiGetAuctionPaymentIntentQueryOptions = <TData = Awaited<ReturnType<typeof apiGetAuctionPaymentIntent>>, TError = ErrorType<BackendErrorEntity>>(auctionId: MaybeRef<string | undefined | null>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetAuctionPaymentIntent>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiGetAuctionPaymentIntentQueryKey(auctionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGetAuctionPaymentIntent>>> = () => apiGetAuctionPaymentIntent(auctionId, requestOptions);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(auctionId))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiGetAuctionPaymentIntent>>, TError, TData> 
}

export type ApiGetAuctionPaymentIntentQueryResult = NonNullable<Awaited<ReturnType<typeof apiGetAuctionPaymentIntent>>>
export type ApiGetAuctionPaymentIntentQueryError = ErrorType<BackendErrorEntity>



export function useApiGetAuctionPaymentIntent<TData = Awaited<ReturnType<typeof apiGetAuctionPaymentIntent>>, TError = ErrorType<BackendErrorEntity>>(
 auctionId: MaybeRef<string | undefined | null>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetAuctionPaymentIntent>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiGetAuctionPaymentIntentQueryOptions(auctionId,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiGetDirectSalePaymentIntentOrder = (
    directSaleId: MaybeRef<string | undefined | null>,
    orderId: MaybeRef<string | undefined | null>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      directSaleId = unref(directSaleId);
orderId = unref(orderId);
      
      return fetchApiInstance<PaymentIntentEntity>(
      {url: `/paymentProvider/directSale/${directSaleId}/paymentIntent/order/${orderId}`, method: 'GET'
    },
      options);
    }
  

export const getApiGetDirectSalePaymentIntentOrderQueryKey = (directSaleId: MaybeRef<string | undefined | null>,
    orderId: MaybeRef<string | undefined | null>,) => {
    return ['paymentProvider','directSale',directSaleId,'paymentIntent','order',orderId] as const;
    }

    
export const getApiGetDirectSalePaymentIntentOrderQueryOptions = <TData = Awaited<ReturnType<typeof apiGetDirectSalePaymentIntentOrder>>, TError = ErrorType<BackendErrorEntity>>(directSaleId: MaybeRef<string | undefined | null>,
    orderId: MaybeRef<string | undefined | null>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetDirectSalePaymentIntentOrder>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiGetDirectSalePaymentIntentOrderQueryKey(directSaleId,orderId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGetDirectSalePaymentIntentOrder>>> = () => apiGetDirectSalePaymentIntentOrder(directSaleId,orderId, requestOptions);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(directSaleId) && unref(orderId))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiGetDirectSalePaymentIntentOrder>>, TError, TData> 
}

export type ApiGetDirectSalePaymentIntentOrderQueryResult = NonNullable<Awaited<ReturnType<typeof apiGetDirectSalePaymentIntentOrder>>>
export type ApiGetDirectSalePaymentIntentOrderQueryError = ErrorType<BackendErrorEntity>



export function useApiGetDirectSalePaymentIntentOrder<TData = Awaited<ReturnType<typeof apiGetDirectSalePaymentIntentOrder>>, TError = ErrorType<BackendErrorEntity>>(
 directSaleId: MaybeRef<string | undefined | null>,
    orderId: MaybeRef<string | undefined | null>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetDirectSalePaymentIntentOrder>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiGetDirectSalePaymentIntentOrderQueryOptions(directSaleId,orderId,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiGetDirectSalePaymentIntentNegotiation = (
    directSaleId: MaybeRef<string | undefined | null>,
    negotiationId: MaybeRef<string | undefined | null>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      directSaleId = unref(directSaleId);
negotiationId = unref(negotiationId);
      
      return fetchApiInstance<PaymentIntentEntity>(
      {url: `/paymentProvider/directSale/${directSaleId}/paymentIntent/negotiation/${negotiationId}`, method: 'GET'
    },
      options);
    }
  

export const getApiGetDirectSalePaymentIntentNegotiationQueryKey = (directSaleId: MaybeRef<string | undefined | null>,
    negotiationId: MaybeRef<string | undefined | null>,) => {
    return ['paymentProvider','directSale',directSaleId,'paymentIntent','negotiation',negotiationId] as const;
    }

    
export const getApiGetDirectSalePaymentIntentNegotiationQueryOptions = <TData = Awaited<ReturnType<typeof apiGetDirectSalePaymentIntentNegotiation>>, TError = ErrorType<BackendErrorEntity>>(directSaleId: MaybeRef<string | undefined | null>,
    negotiationId: MaybeRef<string | undefined | null>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetDirectSalePaymentIntentNegotiation>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiGetDirectSalePaymentIntentNegotiationQueryKey(directSaleId,negotiationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGetDirectSalePaymentIntentNegotiation>>> = () => apiGetDirectSalePaymentIntentNegotiation(directSaleId,negotiationId, requestOptions);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(directSaleId) && unref(negotiationId))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiGetDirectSalePaymentIntentNegotiation>>, TError, TData> 
}

export type ApiGetDirectSalePaymentIntentNegotiationQueryResult = NonNullable<Awaited<ReturnType<typeof apiGetDirectSalePaymentIntentNegotiation>>>
export type ApiGetDirectSalePaymentIntentNegotiationQueryError = ErrorType<BackendErrorEntity>



export function useApiGetDirectSalePaymentIntentNegotiation<TData = Awaited<ReturnType<typeof apiGetDirectSalePaymentIntentNegotiation>>, TError = ErrorType<BackendErrorEntity>>(
 directSaleId: MaybeRef<string | undefined | null>,
    negotiationId: MaybeRef<string | undefined | null>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetDirectSalePaymentIntentNegotiation>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiGetDirectSalePaymentIntentNegotiationQueryOptions(directSaleId,negotiationId,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiGetPaymentMethods = (
    
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      
      
      return fetchApiInstance<PaymentMethodEntity[]>(
      {url: `/paymentProvider/paymentMethods`, method: 'GET'
    },
      options);
    }
  

export const getApiGetPaymentMethodsQueryKey = () => {
    return ['paymentProvider','paymentMethods'] as const;
    }

    
export const getApiGetPaymentMethodsQueryOptions = <TData = Awaited<ReturnType<typeof apiGetPaymentMethods>>, TError = ErrorType<BackendErrorEntity>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetPaymentMethods>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiGetPaymentMethodsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGetPaymentMethods>>> = () => apiGetPaymentMethods(requestOptions);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiGetPaymentMethods>>, TError, TData> 
}

export type ApiGetPaymentMethodsQueryResult = NonNullable<Awaited<ReturnType<typeof apiGetPaymentMethods>>>
export type ApiGetPaymentMethodsQueryError = ErrorType<BackendErrorEntity>



export function useApiGetPaymentMethods<TData = Awaited<ReturnType<typeof apiGetPaymentMethods>>, TError = ErrorType<BackendErrorEntity>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetPaymentMethods>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiGetPaymentMethodsQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiWebhook = (
    
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      
      
      return fetchApiInstance<void>(
      {url: `/paymentProvider/webhook`, method: 'POST'
    },
      options);
    }
  


export const getApiWebhookMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiWebhook>>, TError,void, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiWebhook>>, TError,void, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiWebhook>>, void> = () => {
          

          return  apiWebhook(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiWebhookMutationResult = NonNullable<Awaited<ReturnType<typeof apiWebhook>>>
    
    export type ApiWebhookMutationError = ErrorType<unknown>

    export const useApiWebhook = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiWebhook>>, TError,void, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiWebhook>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getApiWebhookMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiGetSetupIntent = (
    
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      
      
      return fetchApiInstance<SetupIntentEntity>(
      {url: `/paymentProvider/setupIntent`, method: 'GET'
    },
      options);
    }
  

export const getApiGetSetupIntentQueryKey = () => {
    return ['paymentProvider','setupIntent'] as const;
    }

    
export const getApiGetSetupIntentQueryOptions = <TData = Awaited<ReturnType<typeof apiGetSetupIntent>>, TError = ErrorType<BackendErrorEntity>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetSetupIntent>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiGetSetupIntentQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGetSetupIntent>>> = () => apiGetSetupIntent(requestOptions);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiGetSetupIntent>>, TError, TData> 
}

export type ApiGetSetupIntentQueryResult = NonNullable<Awaited<ReturnType<typeof apiGetSetupIntent>>>
export type ApiGetSetupIntentQueryError = ErrorType<BackendErrorEntity>



export function useApiGetSetupIntent<TData = Awaited<ReturnType<typeof apiGetSetupIntent>>, TError = ErrorType<BackendErrorEntity>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetSetupIntent>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiGetSetupIntentQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



export const apiUpdateCardPaymentMethod = (
    paymentMethodId: MaybeRef<string | undefined | null>,
    patchCardPaymentMethodBodyDto: MaybeRef<PatchCardPaymentMethodBodyDto>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      paymentMethodId = unref(paymentMethodId);
patchCardPaymentMethodBodyDto = unref(patchCardPaymentMethodBodyDto);
      
      return fetchApiInstance<PaymentMethodEntity>(
      {url: `/paymentProvider/cardPaymentMethod/${paymentMethodId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchCardPaymentMethodBodyDto
    },
      options);
    }
  


export const getApiUpdateCardPaymentMethodMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUpdateCardPaymentMethod>>, TError,{paymentMethodId: string;data: BodyType<PatchCardPaymentMethodBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiUpdateCardPaymentMethod>>, TError,{paymentMethodId: string;data: BodyType<PatchCardPaymentMethodBodyDto>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiUpdateCardPaymentMethod>>, {paymentMethodId: string;data: BodyType<PatchCardPaymentMethodBodyDto>}> = (props) => {
          const {paymentMethodId,data} = props ?? {};

          return  apiUpdateCardPaymentMethod(paymentMethodId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiUpdateCardPaymentMethodMutationResult = NonNullable<Awaited<ReturnType<typeof apiUpdateCardPaymentMethod>>>
    export type ApiUpdateCardPaymentMethodMutationBody = BodyType<PatchCardPaymentMethodBodyDto>
    export type ApiUpdateCardPaymentMethodMutationError = ErrorType<BackendErrorEntity>

    export const useApiUpdateCardPaymentMethod = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUpdateCardPaymentMethod>>, TError,{paymentMethodId: string;data: BodyType<PatchCardPaymentMethodBodyDto>}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiUpdateCardPaymentMethod>>,
        TError,
        {paymentMethodId: string;data: BodyType<PatchCardPaymentMethodBodyDto>},
        TContext
      > => {

      const mutationOptions = getApiUpdateCardPaymentMethodMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const apiDetachPaymentMethod = (
    paymentMethodId: MaybeRef<string | undefined | null>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      paymentMethodId = unref(paymentMethodId);
      
      return fetchApiInstance<void>(
      {url: `/paymentProvider/detachPaymentMethod/${paymentMethodId}`, method: 'POST'
    },
      options);
    }
  


export const getApiDetachPaymentMethodMutationOptions = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDetachPaymentMethod>>, TError,{paymentMethodId: string}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiDetachPaymentMethod>>, TError,{paymentMethodId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiDetachPaymentMethod>>, {paymentMethodId: string}> = (props) => {
          const {paymentMethodId} = props ?? {};

          return  apiDetachPaymentMethod(paymentMethodId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiDetachPaymentMethodMutationResult = NonNullable<Awaited<ReturnType<typeof apiDetachPaymentMethod>>>
    
    export type ApiDetachPaymentMethodMutationError = ErrorType<BackendErrorEntity>

    export const useApiDetachPaymentMethod = <TError = ErrorType<BackendErrorEntity>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiDetachPaymentMethod>>, TError,{paymentMethodId: string}, TContext>, request?: SecondParameter<typeof fetchApiInstance>}
): UseMutationReturnType<
        Awaited<ReturnType<typeof apiDetachPaymentMethod>>,
        TError,
        {paymentMethodId: string},
        TContext
      > => {

      const mutationOptions = getApiDetachPaymentMethodMutationOptions(options);

      return useMutation(mutationOptions);
    }
    